"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLootboxRedemptionsResponseToJSON = exports.GetLootboxRedemptionsResponseFromJSONTyped = exports.GetLootboxRedemptionsResponseFromJSON = void 0;
var _1 = require("./");
function GetLootboxRedemptionsResponseFromJSON(json) {
    return GetLootboxRedemptionsResponseFromJSONTyped(json, false);
}
exports.GetLootboxRedemptionsResponseFromJSON = GetLootboxRedemptionsResponseFromJSON;
function GetLootboxRedemptionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lootboxRedemptions': (json['lootboxRedemptions'].map(_1.LootboxRedemptionFromJSON)),
    };
}
exports.GetLootboxRedemptionsResponseFromJSONTyped = GetLootboxRedemptionsResponseFromJSONTyped;
function GetLootboxRedemptionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'lootboxRedemptions': (value.lootboxRedemptions.map(_1.LootboxRedemptionToJSON)),
    };
}
exports.GetLootboxRedemptionsResponseToJSON = GetLootboxRedemptionsResponseToJSON;
